'use client';
import React from 'react';

interface DivProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export default function Div({ className, style, children }: DivProps) {
  return <div className={className} style={style}>{children}</div>;
}